import React from 'react';
import Hero from '../sections/Hero';
import Services from '../sections/Services';
import WhatMakesUsDifferent from '../sections/WhatMakesUsDifferent';
import Testimonial from '../sections/Testimonial';
import HowItWorks from '../sections/HowItWorks';
import CTASection from '../sections/CTASection';
import CaseStudies from '../sections/CaseStudies';
import Logos from '../sections/Logos';

const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <WhatMakesUsDifferent />
      {/* <Testimonial /> */}
      <HowItWorks />
      <CTASection />
      {/* <CaseStudies /> */}
      {/* <Logos /> */}
    </main>
  );
};

export default Home;
